import { useState } from 'react'
import UtentiService from '../services/UtentiService/UtentiService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useUtenti = () => {
    const [loadingState, setLoadingState] = useState({
      isLoadingUtenti: false,
      isLoadingUtentiByAgenzia: false,
      isLoadingUtentiCreating: false,
      isLoadingUserByRole: false,
      isLoadingUtentiDeleting: false,
      isLoadingUtentiUpdate: false,
      isLoadingResendEmail: false,
      isLoadingResendEmailNoAuth: false,
      isLoadingInviteFriend: false,
      isLoadingUtenteByParams: false,
      isLoadingUtenteByParamsModal: false,
      isLoadingUtentiEnable: false,
      isLoadingUtentiDisable: false,
      });

    const [modalState, setModalState] = useState({
      showModalCreateUtente: false,
      showModalInfoUtente: false,
      showModalDeleteUtente: false,
      showModalUpdateUtente: false,
      showModalEnableUtente: false,
      showModalDisableUtente: false,
    });

    const getAllUtenti = async () => {
        setLoadingState({ ...loadingState, isLoadingUtenti: true });
        try {
          let response = await UtentiService.getAllUtenti();
          if (response.ok) {
            const utenti = await response.json();
            return utenti;
          } 
        } catch (error) {
          handleError(error)
        } finally {
            setLoadingState({ ...loadingState, isLoadingUtenti: false });
        }
      };

      const deleteUtente = async (data) => {
        setLoadingState({ ...loadingState, isLoadingUtentiDeleting: true });
        try {
          let response = await UtentiService.deleteUtente(data);
          setModalState({ ...modalState, showModalDeleteUtente: false });
          alertService.success("Invito ritirato con successo", {autoClose: true});
          return response;
        } catch (error) {
          handleError(error, {
            NOT_FOUND: "L'utente con l'email specificata non è stato trovato"
          })
        } finally {
            setLoadingState({ ...loadingState, isLoadingUtentiDeleting: false });
        }
      };

      const enableUtente = async (data) => {
        setLoadingState({ ...loadingState, isLoadingUtentiEnable: true });
        try {
          let response = await UtentiService.enableUtente(data);
          alertService.success("Utente riabilitato con successo", {autoClose: true});
          return response;
        } catch (error) {
          handleError(error)
        } finally {
            setLoadingState({ ...loadingState, isLoadingUtentiEnable: false });
        }
      };

      const disableUtente = async (data) => {
        setLoadingState({ ...loadingState, isLoadingUtentiDisable: true });
        try {
          let response = await UtentiService.disableUtente(data);
          alertService.success("Utente disabilitato con successo", {autoClose: true});
          return response.success;
        } catch (error) {
          handleError(error)
        } finally {
            setLoadingState({ ...loadingState, isLoadingUtentiDisable: false });
        }
      };

      const findUsersByRole = async (role) => {
        setLoadingState({ ...loadingState, isLoadingUserByRole: true });
        try {
          let response = await UtentiService.findByRole(role);
          return response;
        } catch (error) {
          handleError(error)
        } finally {
            setLoadingState({ ...loadingState, isLoadingUserByRole: false });
        }
      };

      const createUtente = async (data) => {
        setLoadingState({ ...loadingState, isLoadingUtentiCreating: true });
        try {
          let response = await UtentiService.createUtente(data);
          setModalState(state => ({...state, showModalCreateUtente: false}));
          alertService.success("Utente creato con successo", { autoClose: true });
          return response;
        } catch (err) {
          handleError(err, {
            RESOURCE_ALREADY_EXISTS: "L'utente con l'email specificata è già esistente",
            EMAIL_ERROR: "Inserisci un indirizzo email valido"
          })
        } finally {
            setLoadingState({ ...loadingState, isLoadingUtentiCreating: false });
        }
      };

      const resendEmail = async (data) => {
        setLoadingState({ ...loadingState, isLoadingResendEmail: true });
        try {
          let response = await UtentiService.resendEmail(data);
          alertService.success(`Un nuovo invito è stato inviato a ${data?.username}`, {autoClose: true});
          return response;
        } catch (err) {
          handleError(err, {
            NOT_FOUND: "L'utente con l'email specificata non esiste"
          }
          )
        } finally {
            setLoadingState({ ...loadingState, isLoadingResendEmail: false });
        }
      };

      const resendEmailNoAuth = async (data) => {
        setLoadingState({ ...loadingState, isLoadingResendEmailNoAuth: true });
        try {
          let response = await UtentiService.resendEmailNoAuth(data);
          alertService.success(`Email inviata con successo`, {autoClose: true});
          return response;
        } catch (err) {
          handleError(err, {
            NOT_FOUND: "L'utente con l'email specificata non esiste"
          }
          )
        } finally {
            setLoadingState({ ...loadingState, isLoadingResendEmailNoAuth: false });
        }
      };

      const findByIdAgenzia = async (data) => {
        setLoadingState({ ...loadingState, isLoadingUtentiByAgenzia: true });
        try {
          let response = await UtentiService.findByIdAgenzia(data);
          if(response?.length > 0) {
            const users = response.filter(user => user.tipo_utente === "corsista")
            return users;
          }
          return [];
        } catch (err) {
          handleError(err)
        } finally {
            setLoadingState({ ...loadingState, isLoadingUtentiByAgenzia: false });
        }
      };

      const inviteFriend = async (data) => {
        setLoadingState({ ...loadingState, isLoadingInviteFriend: true });
        try {
          let response = await UtentiService.inviteFriend(data);
          if(response){
            alertService.success("Invito inviato con successo", {autoClose: true});
          }
          return response;
        } catch (err) {
          handleError(err, {
            NOT_FOUND: "L'utente con l'email specificata non è stato trovato"
          })
        } finally {
            setLoadingState({ ...loadingState, isLoadingInviteFriend: false });
        }
      }


      const getUtenteByParams = async (params, isModal = false) => {
        if(isModal) {
          setLoadingState({ ...loadingState, isLoadingUtenteByParamsModal: true });
        } else {
          setLoadingState({ ...loadingState, isLoadingUtenteByParams: true });
        }
        try {
          let obj;
          let response = await UtentiService.getUtenteByParams(params);
          const res = await response.json();
          const totalRecord = response.headers.get('X-Total-Record');
            obj = {
              data: res,
              count: totalRecord
            }
          return obj
        } catch (err) {
          handleError(err)
        } finally {
          if(isModal) {
            setLoadingState({ ...loadingState, isLoadingUtenteByParamsModal: false });
          } else {
            setLoadingState({ ...loadingState, isLoadingUtenteByParams: false });
          }
        }
      }

      const updateUtente = async (data) => {
        setLoadingState({ ...loadingState, isLoadingUtentiUpdate: true });
      
        try {
          // Costruzione del FormData manuale
          const formData = new FormData();
      
          for (const key in data) {
            if (
              data[key] !== null &&
              data[key] !== undefined &&
              key !== 'file_documento' &&
              key !== 'file_codicefiscale'
            ) {
              formData.append(key, data[key]);
            }
          }
      
          if (data.file_documento) {
            formData.append('documentoRiconoscimento', data.file_documento);
          }
      
          if (data.file_codicefiscale) {
            formData.append('codiceFiscale', data.file_codicefiscale);
          }
      
          // Debug: stampa tutti i valori nel FormData
          for (let pair of formData.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
          }
      
          // Chiamata diretta fetch (bypass ApiService per ora)
          const response = await fetch(`${process.env.REACT_APP_REST_ENDPOINT}/utenti/update`, {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
              // ❌ Non mettere Content-Type, lo imposta fetch automaticamente con boundary
            },
            body: formData,
          });
      
          const result = await response.json();
          if (!response.ok) throw result;
      
          alertService.success("Profilo aggiornato con successo", { autoClose: true });
          return result;
        } catch (error) {
          handleError(error);
        } finally {
          setLoadingState({ ...loadingState, isLoadingUtentiUpdate: false });
        }
      };
      

      // const updateUtente = async (data) => {
      //   setLoadingState({ ...loadingState, isLoadingUtentiUpdate: true });
      //   try {
      //     let response = await UtentiService.updateUtente(data);
      //     alertService.success("profilo aggiornato con successo", {autoClose: true});
      //     return response;
      //   } catch (error) {
      //     handleError(error)
      //   } finally {
      //       setLoadingState({ ...loadingState, isLoadingUtentiUpdate: false });
      //   }
      // };

  return {
    loadingStateUtenti: loadingState,
    modalStateUtenti: modalState,
    setModalStateUtenti: setModalState,
    getAllUtenti,
    createUtente,
    findUsersByRole,
    findByIdAgenzia,
    deleteUtente,
    resendEmailNoAuth,
    resendEmail,
    inviteFriend,
    getUtenteByParams,
    disableUtente,
    enableUtente,
    updateUtente
  };      
}

export default useUtenti;